import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import * as DependenciesV2Store from '../../../../redux/dependenciesV2';
import { Badge, BadgeColors, BadgeShapes } from '../../../generic/Badge';
import List from '../../../generic/List';
import PaginationRangeWithControl from '../../../generic/Pagination/PaginationRangeWithControl';
import PartialResultRefreshButton from '../../generic/PartialResult/PartialResultRefreshButton';
import useFetchDependencyAction from '../hooks/useFetchDependencyAction';
import type { DependencyV2Modals } from '../hooks/useDependencyModals';

import DependencyTableContents from './DependencyTableContents';

import styles from '../dependencies.module.less';

type Props = {
  modals: DependencyV2Modals;
};

const DependenciesTable: VoidFunctionComponent<Props> = ({ modals }) => {
  const isLoading = useSelector(DependenciesV2Store.selectors.getAreDependenciesLoading);
  const totalDependencyCount = useSelector(DependenciesV2Store.selectors.getTotalDependencies);

  const page = useSelector(DependenciesV2Store.selectors.getPage);
  const count = useSelector(DependenciesV2Store.selectors.getCount);
  const totalItems = useSelector(DependenciesV2Store.selectors.getTotalDependencies);

  const setPage = useFetchDependencyAction(DependenciesV2Store.actions.setPage);

  return (
    <div className={styles.DependenciesTable}>
      <List>
        <List.Header>
          <div className={styles.DependenciesTableHeader}>
            <div className={styles.DependenciesTableHeaderTitle}>
              <span>Dependencies</span>
              <Badge shape={BadgeShapes.Circle} color={BadgeColors.LightGray}>
                {!isLoading ? totalDependencyCount : '...'}
              </Badge>
              {!isLoading && <PartialResultRefreshButton />}
            </div>
            <div className={styles.DependenciesTableHeaderPagination}>
              <PaginationRangeWithControl
                page={page}
                count={count}
                totalItems={totalItems}
                setPage={setPage}
              />
            </div>
          </div>
        </List.Header>
        <List.Body>
          <DependencyTableContents modals={modals} />
        </List.Body>
      </List>
    </div>
  );
};

export default DependenciesTable;
